module.exports = __webpack_public_path__ + "static/media/oauth-logo-github.2ef7658f.svg";